import React from "react";
import PropTypes from "prop-types";
import { useApi } from "@modules/hooks";
import { getPayslipDetail } from "@modules/hr/payroll/payslip/services";
import PayslipDetailComponent from "@modules/hr/payroll/payslip/components/payslip-detail";

function PayslipDetail(props) {

  const { response } = useApi(getPayslipDetail, props.id, [props.id]);

  if (response == null) {
    return <div>loading...</div>;
  }

  return (
    <div>
      <PayslipDetailComponent 
        entity={response}
        profilePage={true}
      />
    </div>
  );
}

PayslipDetail.propTypes = {
  id: PropTypes.number,
};

export default PayslipDetail;